
export const sorts: Array<ISort> = [
    {
      title: 'جدیدترین',
      value: 'lastest',
    },
    {
      title: 'ارزان ترین',
      value: 'cheapest',
    },
    {
        title: 'گران ترین',
        value: 'most_expensive',
      },
  ];
  